import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet';
import config from '../configuration/config.json';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { Buffer } from 'buffer';
import { Base64 } from 'js-base64';
import { v4 as uuidv4 } from 'uuid';
import './IDProofing.css';
import { Row, Col, Button, Alert, Card } from 'react-bootstrap';

Base64.extendUint8Array();

function CheckStatus() {
    const title = 'goID ID Proofing Portal';
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [applink, setApplink] = useState("");
    //const [cardType, setCardType] = useState("");
    //const [isNFC, setIsNFC] = useState(false);
    const [show, setShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [sedForChvScenario, setSedForChvScenario] = useState(false);
    const [aidForChvScenario, setAidForChvScenario] = useState("");
    let { aid, cardType } = useParams();
    useEffect(() => {
            (async () => {
                try {
                    await checkCHVDataExists();
                } catch (err) {
                    console.error(err);
                }
            })();
    }, []);

    async function startVerify(verifierid) {

        try {
            let headers = {
                'Authorization': "Bearer " + config.idproofing.token
            };

            const response = await axios.request({
                method: 'POST',
                url: config.idproofing.apibaseurl + "idproofing/qrcode/reader/request/" + verifierid + "/" + aid,
                headers: headers,
                responseType: 'arraybuffer',
                responseEncoding: 'binary'
            });

            if (response.status == 200) {
                let applinkd = new Buffer(response.data);
                var qrData = config.idproofing.deeplinkurl + applinkd.toBase64URL();
                setApplink(qrData);
                setIsLoading(false);
            } else {
                setIsLoading(false);
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse)
                setErrorMessage(jsonData.message);
                setShow(true);
            }

        } catch (e) {
            if (e.response != null && e.response.data != null) {
                let jsonData = JSON.parse(e.response.data);
                setErrorMessage(jsonData.message);
            }
            else { 
                setErrorMessage(e.message);
            }
            setShow(true);
            setIsLoading(false);
        }
    }

    async function openwebShare(text) {
        try {

            let resultURL = config.idproofing.baseurl + "idproofing/startidproofingchv/" + aid + "/checkstatus";

            if (window.location.href.replaceAll(' ', '').includes('checkstatus')) {
                resultURL = config.idproofing.baseurl + "idproofing/startidproofingchv/" + aidForChvScenario + "/chvscenario";
            }

            const shareData = {
                text: text,
                url: resultURL,
            };

            await navigator.share(shareData);
        } catch (e) {
            setErrorMessage(e.message);
            setShow(true);
        }
    }

    async function checkCHVDataExists() {
        try {
            setIsLoading(true);
         

                let headers = {
                    'Authorization': "Bearer " + config.idproofing.token
                };
                const response = await axios.request({
                    method: 'GET',
                    url: config.idproofing.apibaseurl + "idproofing/checkchvresult/" + aid,
                    headers: headers,
                    responseType: 'application/json'
                });

                if (response.status == 200) {

                    let apiResponse = response.data;
                    let jsonData = JSON.parse(apiResponse);


                    /* To be verified chv is exists or not */
                    if (jsonData.chv) {
                        navigate('/idproofing/verification/' + aid);
                    }
                    else if (jsonData.portrait) {
                        navigate('/idproofing/selfi/' + aid + '/' + jsonData.cardType);
                    } else {
                        navigate('/idproofing/verification/' + aid);
                    }
                } else {
                    setIsLoading(false);
                    let apiResponse = response.data;
                    let jsonData = JSON.parse(apiResponse);
                    setErrorMessage(jsonData.message);
                    setShow(true);
                }
                setIsLoading(false);

           

        } catch (e) {
            if (e.response != null && e.response.data != null) {
                let jsonData = JSON.parse(e.response.data);
                setErrorMessage(jsonData.message);
            }
            else { 
                setErrorMessage(e.message);
            }
            setShow(true);
            setIsLoading(false);
        }
    }

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>

            <main className="mainbg">
                <div class="container-fluid  text-center">
                    <div class="row">
                        <div class="col bannerdisplay">
                            
                            <div className="headerdiv">
                                <h1 className="headerdisplay">{title}</h1>
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col scancontentarea">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col">
                                        <div class="loader-container">
                                            <div class="loading-text">
                                                {
                                                    "Processing "
                                                }
                                                <span class="dots"></span></div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Alert show={show} variant="danger" onClose={() => setShow(false)} dismissible>
                <Alert.Heading>Error!</Alert.Heading>
                <p>
                    {errorMessage}.
                </p>
            </Alert>
        </>
    );
}

export default CheckStatus;
